import loadable from '@loadable/component';

export const LoadableHermesNotFoundPage = loadable(
  () =>
    import(
      /* webpackChunkName: "LoadableHermesNotFoundPage" */ './HermesNotFoundPage'
    ),
);
